function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 124,
  fill: "#edebdc",
  r: 90
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#4c241d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m103.879 107.211c-1.551 0-3.025-.908-3.678-2.422-.871-2.031.066-4.383 2.098-5.256l12.123-5.209c2.023-.875 4.377.066 5.254 2.098.871 2.029-.066 4.381-2.098 5.254l-12.121 5.209c-.516.22-1.051.326-1.578.326z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m111.879 119.211c-1.551 0-3.025-.908-3.678-2.422-.871-2.031.066-4.383 2.098-5.256l12.123-5.209c2.021-.875 4.379.066 5.254 2.098.871 2.029-.066 4.381-2.098 5.254l-12.121 5.209c-.516.22-1.051.326-1.578.326z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m121.879 129.211c-1.551 0-3.025-.908-3.678-2.422-.871-2.031.066-4.383 2.098-5.256l12.123-5.209c2.02-.877 4.379.064 5.254 2.098.871 2.029-.066 4.381-2.098 5.254l-12.121 5.209c-.516.22-1.051.326-1.578.326z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m143.996 138c-.6 0-1.211-.135-1.785-.422-1.977-.988-2.777-3.391-1.789-5.367l8-16c.986-1.975 3.383-2.781 5.367-1.789 1.977.988 2.777 3.391 1.789 5.367l-8 16c-.701 1.402-2.113 2.211-3.582 2.211z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m157.449 134.547c-.623 0-1.256-.145-1.846-.453-1.959-1.023-2.719-3.439-1.697-5.396l6.547-12.547c1.023-1.959 3.441-2.719 5.396-1.697 1.959 1.023 2.719 3.439 1.697 5.396l-6.546 12.546c-.715 1.37-2.107 2.151-3.551 2.151z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m169.449 134.547c-.623 0-1.256-.145-1.846-.453-1.959-1.023-2.719-3.439-1.697-5.396l6.547-12.547c1.023-1.959 3.443-2.719 5.396-1.697 1.959 1.023 2.719 3.439 1.697 5.396l-6.546 12.546c-.715 1.37-2.107 2.151-3.551 2.151z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m188 178v84h-32c0-6.627 5.373-12 12-12h8v-16h-.814c-12.805 0-23.186-10.381-23.186-23.186v-26.814z",
  fill: "#44bcd8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m188 266h-32c-2.209 0-4-1.791-4-4 0-8.822 7.178-16 16-16h4v-8.186c-13.494-1.582-24-13.088-24-27v-26.814c0-1.955 1.414-3.625 3.342-3.945l36-6c1.154-.203 2.346.133 3.244.893.896.76 1.414 1.877 1.414 3.053v84c0 2.208-1.791 3.999-4 3.999zm-26.926-8h22.926v-75.277l-28 4.666v23.426c0 10.578 8.607 19.186 19.186 19.186h.814c2.209 0 4 1.791 4 4v16c0 2.209-1.791 4-4 4h-8c-2.955-.001-5.541 1.61-6.926 3.999z",
  fill: "#4c241d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m48 118.545c0-7.689 4.344-14.717 11.221-18.156l.347-.173c16.687-8.343 36.915-4.191 48.966 10.051l23.466 27.733s60-28 100 8l32-60v49.963c0 32.053-25.984 58.037-58.037 58.037h-40.248c-16.225 0-31.541-7.491-41.502-20.298l-40.213-51.702z",
  fill: "#44bcd8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m205.963 198h-40.248c-17.586 0-33.863-7.961-44.66-21.844l-39.155-50.34-34.283-3.289c-2.051-.197-3.617-1.922-3.617-3.982 0-9.262 5.146-17.59 13.432-21.734.006-.002.359-.176.363-.18 18.387-9.188 40.51-4.645 53.791 11.053l21.559 25.477c5.373-2.182 17.857-6.691 33.359-8.629 25.354-3.162 47.459 2.094 64.287 15.236l29.68-55.65c.865-1.617 2.705-2.438 4.5-1.998 1.779.444 3.029 2.044 3.029 3.88v49.963c0 34.207-27.83 62.037-62.037 62.037zm-153.568-83.051 31.988 3.068c1.096.105 2.1.658 2.775 1.527l40.213 51.701c9.268 11.919 23.244 18.755 38.344 18.755h40.248c29.797 0 54.037-24.24 54.037-54.037v-33.963l-24.471 45.883c-.578 1.086-1.625 1.844-2.836 2.057-1.209.217-2.453-.145-3.369-.967-37.525-33.771-95.059-7.613-95.635-7.348-1.641.756-3.582.334-4.742-1.041l-23.467-27.732c-10.896-12.877-29.043-16.604-44.123-9.057-.006.002-.359.178-.363.18-4.445 2.222-7.547 6.257-8.599 10.974z",
  fill: "#4c241d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m210 168s28 28-8 48l8.211 4.692c3.58 2.046 5.789 5.853 5.789 9.976v31.332h-32c0-6.627 5.373-12 12-12h8v-16h-.814c-12.805 0-23.186-10.381-23.186-23.186v-26.814",
  fill: "#44bcd8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m216 266h-32c-2.209 0-4-1.791-4-4 0-8.822 7.178-16 16-16h4v-8.186c-13.494-1.582-24-13.088-24-27v-26.814c0-2.209 1.791-4 4-4s4 1.791 4 4v26.814c0 10.578 8.607 19.186 19.186 19.186h.814c2.209 0 4 1.791 4 4v16c0 2.209-1.791 4-4 4h-8c-2.955 0-5.541 1.611-6.926 4h22.926v-27.332c0-2.682-1.445-5.174-3.775-6.504l-8.209-4.691c-1.254-.717-2.023-2.053-2.016-3.496.008-1.445.795-2.771 2.057-3.473 9.688-5.383 15.117-11.746 16.137-18.914 1.68-11.809-8.92-22.66-9.027-22.768-1.553-1.566-1.549-4.098.016-5.654 1.566-1.555 4.092-1.555 5.646.004.553.553 13.504 13.709 11.293 29.488-1.133 8.088-5.949 15.189-14.346 21.176l2.42 1.383c4.814 2.752 7.805 7.906 7.805 13.449v31.332c-.001 2.209-1.792 4-4.001 4z",
  fill: "#4c241d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m132.949 174-9.926 14.544c-3.367 4.933-10.371 5.63-14.644 1.456l-16.379 16v-18.286c0-5.365 4.452-9.714 9.945-9.714h14.625v-7.132c0-9.316 7.731-16.868 17.269-16.868h3.206",
  fill: "#44bcd8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m92 210c-.523 0-1.051-.102-1.553-.314-1.482-.624-2.447-2.077-2.447-3.686v-18.285c0-7.563 6.256-13.715 13.945-13.715h10.625v-3.131c0-11.508 9.541-20.869 21.268-20.869h3.207c2.209 0 4 1.791 4 4s-1.791 4-4 4h-3.207c-7.316 0-13.268 5.773-13.268 12.869v7.131c0 2.209-1.791 4-4 4h-14.625c-3.277 0-5.945 2.564-5.945 5.715v8.785l9.584-9.361c1.555-1.52 4.035-1.52 5.59 0 1.188 1.16 2.807 1.727 4.471 1.568 1.652-.164 3.139-1.047 4.074-2.42l9.926-14.543c1.248-1.82 3.732-2.295 5.561-1.049 1.824 1.246 2.293 3.734 1.049 5.561l-9.926 14.543c-2.273 3.33-5.879 5.469-9.891 5.869-2.674.27-5.322-.262-7.646-1.479l-13.996 13.672c-.763.744-1.773 1.139-2.796 1.139z",
  fill: "#4c241d"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 106,
  fill: "#4c241d",
  r: 2.959
});

function SvgDino03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dino24",
    enableBackground: "new 0 0 300 300",
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDino03);
export default __webpack_public_path__ + "static/media/dino-03.df14b3b3.svg";
export { ForwardRef as ReactComponent };